export default __webpack_public_path__ + "static/media/Group 27100.26fc5085.svg";